import {createContext, useState} from "react";
import {
    getCurrentBusDateOrCurrentDate,
    getCurrentDateToDatePickerFormat
} from "utils/FormatUtils";

export const ASSET_TRANSFER_CAPTURE_PANEL_HOME_PAGE = "asset-transfer-home";
export const ASSET_TRANSFER_CAPTURE_PANEL_ACTIVITIES_PAGE = "asset-transfer-activities";
export const ASSET_TRANSFER_CAPTURE_PANEL_ENTRY_RESULT = "asset-transfer-result";

export const Context = createContext({});

export const Provider = props => {

    const {children} = props;

    const startEndDate = getCurrentBusDateOrCurrentDate();

    const initAssetTransferFilterState = {
        status: 'ALL',
        startDate: startEndDate,
        endDate: startEndDate
    }

    const getRowStyle = (params) => {
        if (!params.data) return {};
        return params.data.uiStatus ===  'ERROR' || params.data.uiStatus ===  'ERROR - TD TO AMEND'? {backgroundColor: '#f5efef'} : {};
    }

    const initAssetTransferCaptureDisplayState = {
        assetTransferEntry:{
            custRefNum: "",
            instructionType: "",
            accountType: "",
            srcSecCd: "",
            tradeDate: getCurrentDateToDatePickerFormat(),
            settleDate: "",
            settleLocation: "",
            settleCurrency: "",
            settleQuantity: 0,
            settleAmount: 0,
            dtcNumber: "",
            dtcAcctNumber: "",
            fedInstruction:"",
            additionalInfo: "",
            manager: "",
            createdBy: "",
            category:'',
            currencies:[],
            comment:'',
            requestId:'',
            status:'',
            id: null,
            indAssetTranferCancel: false,
            brokerMpidId:'',
            cptyAccountNumber:'',
            resData:[],
            uiStatus:'',
			from:''
        },
        assetTransferActivitiesSearch: {
            managerId: '',
            managerName: '',
            subManagerId: '',
            subManagerName: '',
            accountId: '',
            accountCode: '',
            accountName: '',
            status:'',
            startDate: '',
            endDate: '',
            resData: [],
            badgeInfo: ''
        },
        isSavedTradeList : false,
        savedName:'',
        savedNameListId: '',
        currentPage : ASSET_TRANSFER_CAPTURE_PANEL_HOME_PAGE
    }

    const [showGridToolbar, setShowGridToolbar] = useState(true);
    const [assetTransferPanelFilterState, setAssetTransferPanelFilterState] = useState(JSON.parse(JSON.stringify(initAssetTransferFilterState)));
    const [assetTransferCaptureDisplayState, setAssetTransferCaptureDisplayState] = useState(JSON.parse(JSON.stringify(initAssetTransferCaptureDisplayState)));
    const [headerCheckboxChecked, setHeaderCheckedboxChecked] = useState(false);
    const [selectedAnyCheckbox, setSelectedAnyCheckbox] = useState(false);
    const [selectedRows, setSelectedRows] = useState([])
    const [gridColumnApi, setGridColumnApi] = useState(null);
    const [columnState, setColumnState] = useState(null)
    const [viewClicked, setViewClicked] = useState(false);
    const [amendClicked, setAmendClicked] = useState(false);



    const clearAssetTransferSearchAndLoadHome = () => {
        setAssetTransferCaptureDisplayState(JSON.parse(JSON.stringify(initAssetTransferCaptureDisplayState)));
        setAssetTransferPanelFilterState(JSON.parse(JSON.stringify(initAssetTransferFilterState)));
    }

    const clearAssetTransferEntry = () => {
        assetTransferCaptureDisplayState.assetTransferEntry = JSON.parse(JSON.stringify(initAssetTransferCaptureDisplayState.assetTransferEntry));
    }

    const buildAssetTransferActivitiesSearch = (managerId, managerName, subManagerId, subManagerName, accountId, accountCode, accountName, status, startDate, endDate, resData) => {
        let assetTransferActivitiesSearch = JSON.parse(JSON.stringify(initAssetTransferCaptureDisplayState.assetTransferActivitiesSearch));
        assetTransferActivitiesSearch.managerId = managerId;
        assetTransferActivitiesSearch.managerName = managerName;
        assetTransferActivitiesSearch.subManagerId = subManagerId;
        assetTransferActivitiesSearch.subManagerName = subManagerName;
        assetTransferActivitiesSearch.accountId = accountId;
        assetTransferActivitiesSearch.accountCode = accountCode;
        assetTransferActivitiesSearch.accountName = accountName;
        assetTransferActivitiesSearch.status = status;
        assetTransferActivitiesSearch.startDate = startDate;
        assetTransferActivitiesSearch.endDate = endDate;
        assetTransferActivitiesSearch.resData = resData;
        assetTransferActivitiesSearch.badgeInfo = accountCode && accountName ? accountCode + '-'+ accountName : 'ALL'

        return assetTransferActivitiesSearch;
    }


    const assertTransferContext = {
        assetTransferPanelFilterState,
        setAssetTransferPanelFilterState,
        assetTransferCaptureDisplayState,
        setAssetTransferCaptureDisplayState,
        showGridToolbar,
        setShowGridToolbar,
        clearAssetTransferSearchAndLoadHome,
        clearAssetTransferEntry,
        buildAssetTransferActivitiesSearch,
        headerCheckboxChecked,
        setHeaderCheckedboxChecked,
        selectedRows,
        setSelectedRows,
        selectedAnyCheckbox,
        setSelectedAnyCheckbox,
        gridColumnApi,
        setGridColumnApi,
        columnState,
        setColumnState,
        viewClicked,
        setViewClicked,
        amendClicked, setAmendClicked, getRowStyle
    }

    return <Context.Provider value={assertTransferContext}>{children}</Context.Provider>
};

export const {Consumer} = Context;
